import { Box, Text, HStack, Flex, AspectRatio } from '@chakra-ui/react'
import Image from 'next/image'
import Link from 'next/link'
import BenefitMobile from './benefit-mobie'

const ProductCard07 = () => {
  const productData = {
    titleJP: '培育发根，注入高密度重生',
    titleEN: 'Nurturing hair roots for enhanced density & regeneration',
    subTitle: '平衡头部油脂 / Balance Hair Oil',
    descJP: `强效护法素由纯天然草本提取物精心制作，结合传统中医配方与日本先进提取技术。这种创新方法确保了成分原有生物活性的保存。此保健品不含合成药物，使用安全。它支持肾脏健康，促进血液循环，改善毛发生长周期，促进整体发质的提升`,
    descEN:
      'Hair Regain Vitamin is meticulously crafted from pure natural herbal extracts, harmonizing traditional Chinese medicine formulas with advanced extraction techniques from Japan. This innovative approach preserves the original biological activity of the ingredients. Free from synthetic drugs, this supplement is safe for use. It supports kidney health, enhances blood circulation, improves hair growth cycles, and promotes overall hair vitality.',
    imageUrl:
      'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item-7-1734075592410.png'
  }

  const benefitData = [
    {
      ratio: 548 / 648,
      imageUrl:
        'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item7-1731603449805.png',
      className: 'ml-[-6px]'
    }
  ]

  return (
    <Flex
      flexDir={{
        base: 'column',
        lg: 'row'
      }}
      justifyContent="space-between"
      pt={{
        base: '50px',
        lg: '105px'
      }}
      pb="80px"
      gap={{
        base: 5
      }}
      id="hair-regain"
    >
      <Box
        w={{
          base: '100%',
          lg: '50%'
        }}
        ml={{
          base: '0',
          lg: '-10%'
        }}
      >
        <AspectRatio ratio={1281 / 1508} w="100%">
          <Image src={productData.imageUrl} alt={productData.titleEN} fill />
        </AspectRatio>
      </Box>

      <Box
        w={{
          base: '100%',
          lg: '60%'
        }}
      >
        {/* Title and Subtitle */}
        <Box
          w="100%"
          maxW={{
            base: '100%',
            lg: '650px'
          }}
        >
          <Text textStyle="supplementProductCardTitleJP">
            {productData.titleJP}
          </Text>

          <Text textStyle="supplementProductCardTitleEN" mt={1}>
            {productData.titleEN}
          </Text>

          <Text
            textStyle="supplementProductCardSubTitle"
            bg="#9cb25a"
            w={{
              base: 'auto',
              md: 'max-content'
            }}
            mt={5}
            color="white"
            px={2}
            py={1}
          >
            {productData.subTitle}
          </Text>

          <Text textStyle="supplementProductCardDescJP" mt={5}>
            {productData.descJP}
          </Text>

          <Text textStyle="supplementProductCardDescEN" mt={5}>
            {productData.descEN}
          </Text>
        </Box>

        {/* Benefits */}
        <Box w="100%" mt={5}>
          <AspectRatio
            ratio={1448 / 220}
            w="100%"
            display={{
              base: 'none',
              md: 'block'
            }}
          >
            <Image
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/be-7-1731438361792.png'
              }
              alt="traditional item"
              fill
            />
          </AspectRatio>

          <Box
            display={{
              base: 'block',
              md: 'none'
            }}
          >
            <BenefitMobile items={benefitData} isOne />
          </Box>
        </Box>

        {/* Buy Button */}
        <HStack
          justifyContent={{
            base: 'flex-start',
            md: 'flex-start'
          }}
          alignItems="center"
          gap={4}
          mt={5}
        >
          <Link href="https://habbit.sg/products/health-plus-kampo-hair-regain-vitamin-90s">
            <AspectRatio
              ratio={1537 / 864}
              w={{
                base: '120px',
                sm: '120px',
                md: '140px',
                lg: '160px',
                xl: '160px'
              }}
              _hover={{
                opacity: 0.7
              }}
              mt={3}
            >
              <Image
                src={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/buy-now-btn-1714038035225.png'
                }
                alt="buy now btn"
                fill
              />
            </AspectRatio>
          </Link>

          <Box
            w={{
              base: '244px',
              xl: '244px'
            }}
            mt={2}
          >
            <AspectRatio ratio={123 / 36} w="100%">
              <Image
                src={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item1-certificate-1730969831994.png'
                }
                alt="traditional item"
                fill
              />
            </AspectRatio>
          </Box>
        </HStack>
      </Box>
    </Flex>
  )
}

export default ProductCard07
